/**
 * Image URL helpers for mobile-optimized rendering.
 */

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

/** Convert a relative /api/... path to a full URL; pass-through for external URLs. */
export function absoluteImageUrl(url) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
  if (url.startsWith('/api')) return `${BACKEND}${url}`;
  return url;
}

/**
 * Return the 400×400 thumbnail for an uploaded image, or fall back to the original
 * for external / non-upload URLs.
 *
 *   /api/uploads/abc123.jpg  →  <BACKEND>/api/uploads/abc123_thumb.jpg
 */
export function thumbUrl(url) {
  const abs = absoluteImageUrl(url);
  if (!abs) return '';
  // Only uploaded images have deterministic thumb filenames
  const m = abs.match(/\/api\/uploads\/([a-f0-9]{32})\.(\w+)$/i);
  if (!m) return abs;
  return abs.replace(/(\/api\/uploads\/[a-f0-9]{32})\.(\w+)$/i, (_m, base, ext) => {
    // Thumbnails preserve the format (png stays png, etc.)
    return `${base}_thumb.${ext}`;
  });
}
